module.exports = __webpack_public_path__ + "img/apple.a7b83cd2.svg";